module.exports = __webpack_public_path__ + "img/統計学入門_2_2_問題.40f535c6.png";